<button class="btn btn-primary mr-1" (click)="logout()">{{ 'logout' | translate }}</button>
<button class="btn btn-secondary" (click)="closeModal()">{{ 'cancel' | translate }}</button>
